<!-- Factor-kind sections default to COLLAPSED on first open (the Rates
     Preview is the only thing open by default — the user opens the
     editor primarily to inspect prices). Validation errors auto-expand
     via `sectionErrorCount > 0` so problems aren't hidden. -->
<mat-expansion-panel class="rks" [expanded]="sectionErrorCount > 0"
                     [class.rce-section-invalid]="sectionErrorCount > 0">

  <mat-expansion-panel-header>
    <mat-panel-title>
      <mat-icon>functions</mat-icon>
      <span class="rks-kind-label">{{kindLabel()}}</span>
      <span class="rks-kind-count" *ngIf="factors.length > 0">({{localizeNumber(factors.length)}})</span>
      <span class="rce-error-badge" *ngIf="sectionErrorCount > 0"
            [matTooltip]="sectionErrorCount + ' validation error(s) in this section'">
        <mat-icon>error</mat-icon>{{sectionErrorCount}}
      </span>
    </mat-panel-title>
    <mat-panel-description>
      <span class="rks-kind-desc">{{kindDescription()}}</span>
    </mat-panel-description>
  </mat-expansion-panel-header>

  <div class="rks-body">

    <div *ngIf="factors.length === 0" class="rks-empty">
      <span i18n="@@No factors of this kind yet.">No factors of this kind yet.</span>
    </div>

    <app-rate-factor-editor *ngFor="let factor of factors; let i = index"
                            [factor]="factor"
                            [factorPath]="factorPath(i)"
                            [validation]="validation"
                            [scopeConfig]="scopeConfig"
                            [readOnly]="readOnly"
                            (factorChange)="onChildChange(i, $event)"
                            (factorDelete)="onChildDelete(i)">
    </app-rate-factor-editor>

    <div class="rks-actions">
      <button mat-stroked-button color="primary" (click)="addFactor.emit()" [disabled]="readOnly">
        <mat-icon>add</mat-icon>
        <span i18n="@@Add factor">Add factor</span>
      </button>
    </div>

  </div>
</mat-expansion-panel>

